import CustomEvent from "custom-event";

export function publishEvent(type, value) {
  const event = new CustomEvent(type, value);
  window.dispatchEvent(event);
}
